export default __webpack_public_path__ + "static/mg360logo-f6b0cfc42ce7f7a2d0efb0e8881d300d.png";